import * as React from 'react';
import { Route } from 'react-router-dom';

import LoginPage from './LoginPage';
import ResetPasswordPage from './ResetPasswordPage';

export default function getRoutes(isLogged: boolean) {
    return [
        <Route key="login" path="/login" component={LoginPage} />,
        <Route key="resetPassword" path="/reset-password/:guid" component={ResetPasswordPage} />,
    ];
}



// WEBPACK FOOTER //
// ./src/components/login/Login.Routes.tsx